module.exports = __webpack_public_path__ + "img/Pro_Selected.a37cfe59.svg";